import { gql } from '@apollo/client';

export const GET_SHIPPERS_FRAGMENT = gql`
  fragment Shippers on Query {
    shippers {
      id
      fullName
      isActive
    }
  }
`;
